<template>
    <div>
        <page-header icon-class="mdi mdi-record"
                     :title="isEditMode ? $t('pages.admin.livestream.announcements.add_or_update.title_edit') : $t('pages.admin.livestream.announcements.add_or_update.title_add')"/>

        <static-loading-indicator-icon :with-card="true"/>
        <div class="card shadow-sm" v-if="!$store.getters.shouldLoadLocal">
            <div class="card-body">
                <language-switcher-nav :language.sync="selectedLanguage">
                    <div class="form-group">
                        <label for="title">
                            <strong>
                                {{ $t('pages.admin.livestream.announcements.model.title') }}
                            </strong>
                        </label>

                        <input type="text" id="title" class="form-control" v-model="title[selectedLanguage]" :placeholder="$t('pages.admin.livestream.announcements.model.title')" :class="{'is-invalid': $errors.has('title')}">
                        <error :input="'title.' + selectedLanguage"/>
                    </div>

                </language-switcher-nav>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mt-3">
                            <label for="starts_at_date">
                                <strong>
                                    {{ $t('pages.admin.livestream.announcements.model.starts_at') }}
                                    ({{ $t('pages.admin.livestream.announcements.model.date') }})
                                </strong>
                            </label>

                            <input type="date" id="starts_at_date" class="form-control" v-model="start_date" :placeholder="$t('pages.admin.livestream.announcements.model.starts_at')" :class="{'is-invalid': $errors.has('start_date')}">
                            <error input="start_date"/>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group mt-3">
                            <label for="starts_at_time">
                                <strong>
                                    {{ $t('pages.admin.livestream.announcements.model.starts_at') }}
                                    ({{ $t('pages.admin.livestream.announcements.model.time') }})
                                </strong>
                            </label>

                            <input type="time" id="starts_at_time" class="form-control" v-model="start_time" :placeholder="$t('pages.admin.livestream.announcements.model.starts_at')" :class="{'is-invalid': $errors.has('start_time')}">
                            <error input="start_time"/>
                        </div>
                    </div>
                </div>

                <button class="btn btn-primary" @click="handleSave">
                    {{ isEditMode ? $t('actions.update') : $t('actions.create') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import LanguageSwitcherNav from "../../../Includes/LanguageSwitcherNav";
import AdminLiveStreamAnnouncementRepository
    from "../../../../repositories/Admin/AdminLiveStreamAnnouncementRepository";
import StaticLoadingIndicatorIcon from "../../../Includes/StaticLoadingIndicatorIcon";
import PageHeader from "../../../Includes/PageHeader";
import LiveStreamAnnouncementRepository from "../../../../repositories/Livestream/LiveStreamAnnouncementRepository";
export default {
    name: "LivestreamAnnouncementAddEdit",
    components: {PageHeader, StaticLoadingIndicatorIcon, LanguageSwitcherNav},
    data: () => ({
        announcement: {},
        selectedLanguage: 'en',

        title: {en: '', de: '', lb: ''},
        start_date: null,
        start_time: null,
    }),
    methods: {
        handleSave() {
            if(this.isEditMode)
                this.updateAnnouncement();
            else
                this.createAnnouncement();
        },
        updateAnnouncement() {
            AdminLiveStreamAnnouncementRepository
                .update(this.announcementIdToEdit, {
                    title: this.title,
                    start_date: this.start_date,
                    start_time: this.start_time,
                }).then((res) => {
                    this.$snotify.success(this.$t('actions.updated'));
                    this.$router.push({name: 'admin.livestream.announcement.index'});
                })
        },
        createAnnouncement() {
            AdminLiveStreamAnnouncementRepository
                .create({
                    title: this.title,
                    start_date: this.start_date,
                    start_time: this.start_time,
                }).then((res) => {
                this.$snotify.success(this.$t('actions.created'));
                this.$router.push({name: 'admin.livestream.announcement.index'});
            })
        },
    },
    mounted() {
      if(this.isEditMode) {
          AdminLiveStreamAnnouncementRepository
              .get(this.$route.params.announcement)
              .then((res) => {
                  this.title = res.data.title;

                  this.start_date = this.$date(res.data.starts_at).format('YYYY-MM-DD');
                  this.start_time = this.$date(res.data.starts_at).format('HH:mm');
              })
      }
    },
    computed: {
        announcementIdToEdit() {
            return this.$route.params.announcement ? parseInt(this.$route.params.announcement) : null;
        },
        isEditMode() {
            return this.announcementIdToEdit !== null;
        },
    }
}
</script>

<style scoped>

</style>
